import { Controller } from "@hotwired/stimulus";
import { Turbo } from "@hotwired/turbo-rails";

export default class extends Controller {
  static values = {
    customerCode: String,
  };

  static targets = ["resourceSelect", "checkListSelect", "inspectionItemsFrame", "lastInspectedOnFrame", "inspectedOnDateField"];
  declare readonly customerCodeValue: string;
  declare readonly resourceSelectTarget: HTMLSelectElement;
  declare readonly checkListSelectTarget: HTMLSelectElement;
  declare readonly inspectedOnDateFieldTarget: HTMLInputElement;
  declare inspectionItemsFrameTarget: HTMLIFrameElement;
  declare lastInspectedOnFrameTarget: HTMLIFrameElement;

  private clearItemsUI(): void {
    this.inspectionItemsFrameTarget.innerHTML = "";
    this.lastInspectedOnFrameTarget.innerHTML = "";
  }

  connect() {
    this.disablePlaceholderOn(this.resourceSelectTarget);
    this.disablePlaceholderOn(this.checkListSelectTarget);

    this.disableIfEmpty(this.checkListSelectTarget);
  }

  checkListSelectTargetConnected(el: HTMLSelectElement) {
    this.disablePlaceholderOn(el);

    // 点検簿がセットされたら点検項目を読み込む
    if (this.checkListSelectTarget.value) {
      this.onCheckListSelected();
    }
  }
  resourceSelectTargetConnected(el: HTMLSelectElement) {
    this.disablePlaceholderOn(el);

    // リソースがセットされたら点検簿を読み込む
    if (this.resourceSelectTarget.value) {
      this.onResourceSelected();
    }
  }

  onResourceSelected = async (): Promise<void> => {
    this.clearItemsUI();

    const resourceId = this.resourceSelectTarget.value;
    const inspectedOn = this.inspectedOnDateFieldTarget.value;
    if (!resourceId || !inspectedOn) return;

    const url =
      `/${this.customerCodeValue}/inspections/check_lists` +
      `?resource_id=${encodeURIComponent(resourceId)}` +
      `&inspected_on=${encodeURIComponent(inspectedOn)}`;

    await this.fetchAndRenderTurbo(url);
  };

  onCheckListSelected = async (): Promise<void> => {
    this.clearItemsUI();

    const resourceId = this.resourceSelectTarget.value;
    const checkListId = this.checkListSelectTarget.value;
    const inspectedOn = this.inspectedOnDateFieldTarget.value;
    if (!checkListId || !resourceId || !inspectedOn) return;

    const url =
      `/${this.customerCodeValue}/inspections/inspection_items` +
      `?resource_id=${encodeURIComponent(resourceId)}` +
      `&check_list_id=${encodeURIComponent(checkListId)}` +
      `&inspected_on=${encodeURIComponent(inspectedOn)}`;

    await this.fetchAndRenderTurbo(url);
  };

  private async fetchAndRenderTurbo(url: string): Promise<void> {
    try {
      const res = await fetch(url, {
        headers: { Accept: "text/vnd.turbo-stream.html" },
        credentials: "same-origin",
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const html = await res.text();
      Turbo.renderStreamMessage(html);
    } catch (err) {
      console.error("[Turbo fetch error]", err);
    }
  }

  private disablePlaceholderOn(select?: HTMLSelectElement | null) {
    if (!select) return;
    // value="" の option をプレースホルダとみなす
    const opt = select.querySelector('option[value=""]') as HTMLOptionElement | null;
    if (!opt) return;

    // 初期表示は selected のままにして、選択操作では選べないようにする
    opt.disabled = true;
    opt.hidden = true; // 一覧から消したい場合。消したくなければ hidden 行は外す
  }

  private disableIfEmpty(select?: HTMLSelectElement | null) {
    if (!select) return;

    // 空の option を取り除いた残りが0なら無効化
    const validOptions = Array.from(select.options).filter((opt) => opt.value && !opt.disabled);
    if (validOptions.length === 0) {
      select.disabled = true;
    } else {
      select.disabled = false;
    }
  }
}
